import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { Search } from '@material-ui/icons';
import { InputAdornment } from '@material-ui/core';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsFindBy } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return { description: item.DESCRIPCION };
        }),
        description: dataImport.nameFile
      });
    } else if (dataImport?.success === false) {
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataImport({});
    }
  }, [bPartnerSelect]);

  return (
    <>
      <Modal
        title={`Nueva cobertura bimestral`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cobertura-colgate'
      >
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <TextField
            label="Descripción de la cobertura bimestral"
            type="text"
            defaultValue={dataImport.nameFile || ''}
            margin="normal"
            name="description"
            required
            fullWidth
          />
        </span>
      </Modal>
    </>
  );
});
